<template>
  <v-container fluid class="pa-0">
    
    <!-- Detail  Header -->
    <v-toolbar dark dense fixed :color="`${animalSource.colourCode} darken-4`">
      <v-img :src="logoUrl" max-width="60" class="pl-0 mr-2"></v-img>
      <v-badge overlap small :color="getRankColor(params.rankColor)" :content="params.rank">
        <v-chip small color="blue-grey lighten-1">
          <span class="caption">{{ animalDescriptor }}</span>
        </v-chip>
      </v-badge>
    </v-toolbar>

    <!-- Details -->
    <v-container :style="{ maxHeight: '600px' }"
      class="overflow-y-auto pa-0 ma-0">
      <v-list dense>
        <v-list-item v-for="(item, i) in filteredDetail" :key="i">
          <v-list-item-content>
            <v-list-item-title class="body-2 font-weight-bold">
              {{ item.label }}
            </v-list-item-title>
            <span class="caption font-weight-regular">
              {{ getValue(item) }}
            </span>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-container>
  </v-container>
</template>

<script>
import { AppColor } from '@/config.js'
import { mapGetters } from 'vuex'

export default {
  name: 'BullDetail',
  props: {
    animalSource: {
      type: Object,
      default: null
    },
    bullDetail: {
      type: Array,
      default: null
    },
    params: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      appColor_Medium: AppColor.Medium,
      appColor_Progress: AppColor.Progress
    }
  },
  computed: {
    ...mapGetters(['animalSources']),
    filteredDetail () {
      return this.bullDetail.filter(d => d.label !== 'Calf Id'
        && d.label !== 'Feed Tag'
        && d.label !== 'Visual Id')
    },
    logoUrl () {
      if (this.isNullOrUndefined(this.animalSources)) return ''
      if (this.animalSources.length === 0) return ''
      if (this.animalSource === null) return ''

      const sourceId = this.animalSource.id
      const sources = this.animalSources.filter(src => { return src.id === sourceId })
      return sources.length
        ? sources[0].logoUrl
        : null
    },
    animalDescriptor () {
      return this.params.tag !== null && this.params.tag.length > 0
        ? `${this.params.vid} / ${this.params.tag}`
        : this.params.vid
    }
  },
  methods: {
    getValue (item) {
      if (item.type === 'date') {
        return this.getDateFormat(item.value)
      }
      else if (item.type === 'float') {
        return this.getFloatFormat(item.value)
      }
      
      return (item.type === 'string')
        ? this.isStringNullOrEmnpty(item.value) ? 'N/A' : item.value
        : item.value !== null ? item.value : 'N/A'
    },
    getFloatFormat (floatVal) {
      return Number((floatVal).toFixed(2));
    },
    getDateFormat (date) {
      if (date !== null) {
        if (date.length > 0) {
          return this.$moment(date).format('MMM D YYYY')
        }
      }
      return ''
    },
    getRankColor (color) {
      return color === 'yellow'
        ? 'yellow darken-2'
        : color
    },
    isNullOrUndefined (obj) {
      return obj === undefined 
        || typeof obj === 'undefined' 
        || obj === null
    },
    isStringNullOrEmnpty (s) {
      return s !== null
        ? s.length === 0
        : true
    }
  }
}
</script>
